{
  "route": "practice",
  "railEntries": [
    {
      "label": "Position",
      "anchor": "practice-section-1"
    },
    {
      "label": "Offers",
      "anchor": "practice-section-2"
    },
    {
      "label": "Fit",
      "anchor": "practice-section-3"
    },
    {
      "label": "Narrative",
      "anchor": "practice-section-4"
    },
    {
      "label": "90 days",
      "anchor": "practice-section-5"
    },
    {
      "label": "Message",
      "anchor": "practice-section-6"
    },
    {
      "label": "Naming",
      "anchor": "practice-section-7"
    }
  ],
  "anchors": [
    "practice-section-1",
    "practice-section-2",
    "practice-section-3",
    "practice-section-4",
    "practice-section-5",
    "practice-section-6",
    "practice-section-7"
  ],
  "nodes": [
    {
      "tag": "header",
      "attrs": {
        "class": "chapter-hero"
      },
      "children": [
        {
          "tag": "div",
          "children": [
            {
              "tag": "span",
              "attrs": {
                "class": "chapter-index"
              },
              "children": [
                "05 · The Practice"
              ]
            },
            " ",
            {
              "tag": "h1",
              "attrs": {
                "id": "practice-title"
              },
              "children": [
                "Make the mission ",
                {
                  "tag": "em",
                  "children": [
                    "legible."
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "p",
              "attrs": {
                "class": "chapter-deck"
              },
              "children": [
                "Your consultancy wing is not about bringing a grand theory to every project. It is a disciplined practice for building the mandate, room, portfolio and stewardship that complex transitions are missing."
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "aside",
          "attrs": {
            "class": "chapter-aside"
          },
          "children": [
            {
              "tag": "strong",
              "children": [
                "Recommended public category"
              ]
            },
            "Systems Transition Broker. Use “Earth 3.0” internally while the method earns proof; lead publicly with the missing transition infrastructure and a first demonstrator."
          ]
        },
        " "
      ]
    },
    " ",
    {
      "tag": "div",
      "attrs": {
        "class": "chapter-body"
      },
      "children": [
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-1"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "quote-panel"
              },
              "children": [
                {
                  "tag": "blockquote",
                  "children": [
                    "I help places and institutions build the ",
                    {
                      "tag": "em",
                      "children": [
                        "mandate, room, portfolio and stewardship"
                      ]
                    },
                    " required to move before, through and beyond disruption."
                  ]
                },
                {
                  "tag": "cite",
                  "children": [
                    "Recommended positioning line"
                  ]
                }
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-2"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "section-intro"
              },
              "children": [
                {
                  "tag": "p",
                  "attrs": {
                    "class": "section-label"
                  },
                  "children": [
                    "The offer architecture"
                  ]
                },
                {
                  "tag": "h2",
                  "attrs": {
                    "class": "section-heading"
                  },
                  "children": [
                    "Four engagements. One arc from ",
                    {
                      "tag": "em",
                      "children": [
                        "readiness to handover."
                      ]
                    }
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "panel-grid four"
              },
              "children": [
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel accent offer-card"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "offer-num"
                      },
                      "children": [
                        "01 · DIAGNOSE"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "Transition Readiness Scan"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Read need, pressure, rights, authority, evidence, relationships, resources and shock exposure."
                      ]
                    },
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "deliverable"
                      },
                      "children": [
                        "Field map · gate decision · conditions plan"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel accent offer-card"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "offer-num"
                      },
                      "children": [
                        "02 · CONSTITUTE"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "Commons & Charter Design"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Compose legitimate participation, decision rights, consent, funding, conflict and accountability."
                      ]
                    },
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "deliverable"
                      },
                      "children": [
                        "Charter · mandate map · evidence protocol"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel accent offer-card"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "offer-num"
                      },
                      "children": [
                        "03 · DEMONSTRATE"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "Transition Portfolio"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Build a connected set of hold, cross and grow interventions with learning gates and just-transition safeguards."
                      ]
                    },
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "deliverable"
                      },
                      "children": [
                        "Portfolio · runway · delivery rhythm"
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel accent offer-card"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "offer-num"
                      },
                      "children": [
                        "04 · TRANSFER"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "Stewardship & Learning"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Hold the crossing, publish evidence and transfer capability so the system no longer depends on you."
                      ]
                    },
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "deliverable"
                      },
                      "children": [
                        "Living evidence · handover · replication guide"
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-3"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "section-intro"
              },
              "children": [
                {
                  "tag": "p",
                  "attrs": {
                    "class": "section-label"
                  },
                  "children": [
                    "Engagement filter"
                  ]
                },
                {
                  "tag": "h2",
                  "attrs": {
                    "class": "section-heading"
                  },
                  "children": [
                    "The practice is defined as much by ",
                    {
                      "tag": "em",
                      "children": [
                        "what it refuses."
                      ]
                    }
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "panel-grid"
              },
              "children": [
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel accent"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "evidence-label synthesis"
                      },
                      "children": [
                        "Good fit"
                      ]
                    },
                    {
                      "tag": "h2",
                      "children": [
                        "A real crossing"
                      ]
                    },
                    {
                      "tag": "ul",
                      "attrs": {
                        "class": "plain-list"
                      },
                      "children": [
                        {
                          "tag": "li",
                          "children": [
                            "Shared risk or opportunity is acknowledged"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "Multiple authorities must coordinate"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "Affected people and rights-holders can shape the work"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "Real evidence can be tabled"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "There is runway for proof and learning"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "The client wants capability, not dependence"
                          ]
                        }
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel accent"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "attrs": {
                        "class": "evidence-label proposition"
                      },
                      "children": [
                        "Decline"
                      ]
                    },
                    {
                      "tag": "h2",
                      "children": [
                        "Transition theatre"
                      ]
                    },
                    {
                      "tag": "ul",
                      "attrs": {
                        "class": "plain-list"
                      },
                      "children": [
                        {
                          "tag": "li",
                          "children": [
                            "A predetermined answer needs “buy-in”"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "Community participation is unpaid or symbolic"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "Power and trade-offs must remain unnamed"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "One sponsor expects ownership of the result"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "Urgency is used to bypass rights"
                          ]
                        },
                        {
                          "tag": "li",
                          "children": [
                            "You are expected to carry the system’s will"
                          ]
                        }
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-4"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "section-intro"
              },
              "children": [
                {
                  "tag": "p",
                  "attrs": {
                    "class": "section-label"
                  },
                  "children": [
                    "The narrative"
                  ]
                },
                {
                  "tag": "h2",
                  "attrs": {
                    "class": "section-heading"
                  },
                  "children": [
                    "Do not sell another vision. Name the ",
                    {
                      "tag": "em",
                      "children": [
                        "missing middle."
                      ]
                    }
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "p",
              "attrs": {
                "class": "lead"
              },
              "children": [
                "The strongest public story is simple: ",
                {
                  "tag": "strong",
                  "children": [
                    "we have enough visions and warnings; we lack transition infrastructure."
                  ]
                },
                " Your authority comes from twenty-five years inside the rooms where ambition meets power, readiness and delivery, not from claiming solitary authorship of the future."
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "timeline"
              },
              "children": [
                {
                  "tag": "article",
                  "attrs": {
                    "class": "timeline-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Act 01 · Name"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "The gap"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Publish a sharp essay or op-ed on why good reforms die between announcement and implementation."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "timeline-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Act 02 · Open"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "The field"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Host a small, carefully composed salon: rights, transition, institutions, capital and affected experience."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "timeline-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Act 03 · Prove"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "The method"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Run one bounded demonstrator with a charter, public hypotheses, baseline and stop rules."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "article",
                  "attrs": {
                    "class": "timeline-step"
                  },
                  "children": [
                    {
                      "tag": "span",
                      "children": [
                        "Act 04 · Publish"
                      ]
                    },
                    {
                      "tag": "h3",
                      "children": [
                        "The learning"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        "Release evidence, failures and transferable patterns before making global claims."
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-5"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "section-intro"
              },
              "children": [
                {
                  "tag": "p",
                  "attrs": {
                    "class": "section-label"
                  },
                  "children": [
                    "90-day landing path"
                  ]
                },
                {
                  "tag": "h2",
                  "attrs": {
                    "class": "section-heading"
                  },
                  "children": [
                    "From internal R&D to a ",
                    {
                      "tag": "em",
                      "children": [
                        "credible first invitation."
                      ]
                    }
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "ol",
              "attrs": {
                "class": "number-list"
              },
              "children": [
                {
                  "tag": "li",
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Weeks 1–3 · Constitute the method"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Recruit a small critical advisory circle; stress-test rights, authority and evidence; draft the minimum viable charter."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "li",
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Weeks 2–5 · Select the case"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Run the readiness scan on 2–3 candidates. Choose a bounded case with authority, affected participation and 12-month runway."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "li",
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Weeks 4–7 · Secure legitimacy"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Establish First Peoples rights-holder governance where relevant; fund participation; clarify data and decision protocols."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "li",
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Weeks 6–9 · Publish the point of view"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Release “The Missing Middle of Transition” and a concise method note: problem first, model second."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "li",
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Weeks 8–12 · Compose the demonstrator"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Agree baseline, portfolio, outcome corridor, shocks protocol and public learning cadence before launch."
                      ]
                    }
                  ]
                },
                " ",
                {
                  "tag": "li",
                  "children": [
                    {
                      "tag": "strong",
                      "children": [
                        "Day 90 · Invite, do not declare"
                      ]
                    },
                    {
                      "tag": "span",
                      "children": [
                        "Announce the case, the coalition and what will be tested. Make proof the story."
                      ]
                    }
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-6"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "section-intro"
              },
              "children": [
                {
                  "tag": "p",
                  "attrs": {
                    "class": "section-label"
                  },
                  "children": [
                    "Message house"
                  ]
                },
                {
                  "tag": "h2",
                  "attrs": {
                    "class": "section-heading"
                  },
                  "children": [
                    "One line. Three proof points. ",
                    {
                      "tag": "em",
                      "children": [
                        "No saviour story."
                      ]
                    }
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "table",
              "attrs": {
                "class": "comparison"
              },
              "children": [
                {
                  "tag": "tbody",
                  "children": [
                    {
                      "tag": "tr",
                      "children": [
                        {
                          "tag": "td",
                          "children": [
                            "Core line"
                          ]
                        },
                        {
                          "tag": "td",
                          "attrs": {
                            "colspan": "2"
                          },
                          "children": [
                            "“I help systems build the mandate and capacity to move before, through and beyond disruption.”"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "tr",
                      "children": [
                        {
                          "tag": "td",
                          "children": [
                            "Proof 01"
                          ]
                        },
                        {
                          "tag": "td",
                          "children": [
                            "Readiness"
                          ]
                        },
                        {
                          "tag": "td",
                          "children": [
                            "You know when a room can move, and what conditions must be built when it cannot."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "tr",
                      "children": [
                        {
                          "tag": "td",
                          "children": [
                            "Proof 02"
                          ]
                        },
                        {
                          "tag": "td",
                          "children": [
                            "Composition"
                          ]
                        },
                        {
                          "tag": "td",
                          "children": [
                            "You connect authority, rights, evidence, capital and lived experience around a real case."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "tr",
                      "children": [
                        {
                          "tag": "td",
                          "children": [
                            "Proof 03"
                          ]
                        },
                        {
                          "tag": "td",
                          "children": [
                            "Transfer"
                          ]
                        },
                        {
                          "tag": "td",
                          "children": [
                            "Your exit condition is a system able to keep changing without you."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "tr",
                      "children": [
                        {
                          "tag": "td",
                          "children": [
                            "Avoid"
                          ]
                        },
                        {
                          "tag": "td",
                          "attrs": {
                            "colspan": "2"
                          },
                          "children": [
                            "“I have the answer,” “a universal model,” “healing the planet,” or “no hierarchy” before the power architecture proves those claims."
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " ",
        {
          "tag": "section",
          "attrs": {
            "class": "section-block",
            "id": "practice-section-7"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "section-intro"
              },
              "children": [
                {
                  "tag": "p",
                  "attrs": {
                    "class": "section-label"
                  },
                  "children": [
                    "Naming recommendation"
                  ]
                },
                {
                  "tag": "h2",
                  "attrs": {
                    "class": "section-heading"
                  },
                  "children": [
                    "Keep Earth 3.0 as the lab name. Let the ",
                    {
                      "tag": "em",
                      "children": [
                        "public category be useful."
                      ]
                    }
                  ]
                }
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "panel-grid three"
              },
              "children": [
                {
                  "tag": "article",
                  "attrs": {
                    "class": "panel"
                  },
                  "children": [
                    {
                      "tag": "h3",
                      "children": [
                        "Your role"
                      ]
                    },
                    {
                      "tag": "p",
                      "children": [
                        {
                          "tag": "strong",
                          "children": [
                            "Systems Transition Broker"
                          ]
                        },
                        {
                          "tag": "br"
                        },
                        "Distinctive, accurate and already yours."
                      ]
                    },
                    " ",
                    {
                      "tag": "article",
                      "attrs": {
                        "class": "panel"
                      },
                      "children": [
                        {
                          "tag": "h3",
                          "children": [
                            "The operating unit"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            {
                              "tag": "strong",
                              "children": [
                                "Transition Commons"
                              ]
                            },
                            {
                              "tag": "br"
                            },
                            "Signals shared governance without overclaiming democracy."
                          ]
                        },
                        " ",
                        {
                          "tag": "article",
                          "attrs": {
                            "class": "panel"
                          },
                          "children": [
                            {
                              "tag": "h3",
                              "children": [
                                "The internal model"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                {
                                  "tag": "strong",
                                  "children": [
                                    "Earth 3.0 · v0.1"
                                  ]
                                },
                                {
                                  "tag": "br"
                                },
                                "A research frame that earns its public name through proof."
                              ]
                            },
                            " "
                          ]
                        },
                        " "
                      ]
                    },
                    " ",
                    {
                      "tag": "button",
                      "attrs": {
                        "class": "route-next",
                        "type": "button",
                        "data-go": "sources"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "children": [
                            "Research basis"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Evidence · Sources & lineages →"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "footer",
                      "attrs": {
                        "class": "tiny-footer"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "children": [
                            "05 · The Practice"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Stewardship, not saviourship"
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " "
          ]
        },
        " "
      ]
    }
  ]
}
